import React from "react";
import { cn } from "./cn";

/**
 * Bun skeleton loading: quiet mist-deep bars and circles, gentle pulse.
 * Compose into card-shaped placeholders; keep the shapes roughly matching
 * the loaded content so nothing jumps.
 */
export default function Skeleton({ circle, width, height, className }) {
  return (
    <span
      style={{ width, height }}
      className={cn(
        "block bg-bun-mist-deep animate-pulse",
        circle ? "rounded-full w-[26px] h-[26px]" : "h-[11px] rounded-[6px] w-full",
        className
      )}
    />
  );
}

/** Ready-made card placeholder: avatar + three text bars. */
export function SkeletonCard({ className }) {
  return (
    <div className={cn("border border-bun-line rounded-bun-lg p-[14px] flex flex-col gap-[10px]", className)}>
      <div className="flex items-center gap-[10px]">
        <Skeleton circle />
        <Skeleton width="60%" />
      </div>
      <Skeleton width="90%" />
      <Skeleton width="75%" />
      <Skeleton width="40%" className="bg-bun-mist" />
    </div>
  );
}
